export const NAME = 'AirportCurrentConditions';
